import * as React from 'react';
import {useEffect, useRef, useState} from 'react';
import HighchartsReact from 'highcharts-react-official';
import * as Highcharts from 'highcharts';
import {Card, CardContent} from '@mui/material';
import {COLORS} from '../../../../utils/constants';
import {getDefaultPieFormatting} from '../../charts/pie';

interface INewSalesChannelsProps {
    final: any[];
}

const NewSalesChannels = ({final}: INewSalesChannelsProps) => {
    const chartComponentRef = useRef<HighchartsReact.RefObject>(null);
    const [options, setOptions] = useState<Highcharts.Options>();

    const calculateSubmissions = () => {
        const success = final.filter((submission: any) => submission.sale_channels_t1 === 'Yes').length;
        const unSuccess = final.filter((submission: any) => submission.sale_channels_t1 === 'No').length;

        const data = [
            {
                name: 'Yes',
                y: success,
                color: COLORS.blue,
            },
            {
                name: 'No',
                y: unSuccess,
                color: COLORS.yellow,
            },
        ];
        const title = 'Entry to additional sales channels';
        const dashboardOptions: any = getDefaultPieFormatting(title, data, 1, {
            subtitle: {
                text: '% of entrepreneurs who opened new sales channels',
                align: 'left',
            },
        });

        setOptions(dashboardOptions);
    };

    useEffect(() => {
        calculateSubmissions();
    }, []);

    return (
        <Card className='chart-container'>
            <CardContent>
                {options && (
                    <HighchartsReact
                        highcharts={Highcharts}
                        options={options}
                        ref={chartComponentRef}
                    />
                )}
            </CardContent>
        </Card>
    );
};

export default NewSalesChannels;
